import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import {PlatformLocation} from '@angular/common';
declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-case-practice-influence-list",
  templateUrl: "./case-practice-influence-list.component.html",
  styleUrls: [
    "./case-practice-influence-list.component.css",
  ],
})
export class CasePracticeInfluenceListComponent
  implements OnInit, AfterViewInit {
  @Input() practiceList: any;
  @Input() practiceId: any;
  @Input() learningPathId: any;
  @Input() practiceMetaId: any;
  //接受传入的参数 用于判断是否为访客
  @Input() userType: string;
  @Input() type: string;

  @Output() onGoToNextStep = new EventEmitter<any>();
  @Output() onSetPracticeIndex = new EventEmitter<any>();
  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  chuanjie: any;
  abilityConfig: AbilityConfig;
  //进入新能力考核标识
  version: number = 0;
  //学习 metaId
  learningPathMetaId: number = 0;
  //学习meta 列表
  learningPathMetas: any;
  learningPathSubItems: any;
  goPostSurveyFlag: boolean;
  isOpenClass: number = 0;
  isShowQuestionnaire: boolean = false;
  questionnaireInfo: any = null;
  approachTheme: any = {};
  currentIndex: number = 0;
  isShowApproach: boolean = false;
  alwaysShowSurvey:boolean = true;
  isCustomLock: boolean = false;
  /* 精彩瞬间 */
  showMoment:boolean = false;
  momentList:any = [];

  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  isTencent = false; // 是否腾讯对接
  get showGoToSurveyBtn():boolean{
    return this.practiceList.every(item=>{
      return item.status === 2;
    })
  }
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private platformLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🐍🐍🐍🐍🐍🐍');
    // -------------------------------------------------------------------
    console.log(this.practiceList)
    let temp = true;
    let that = this;
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    localStorage.setItem("moduleId","3");
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);

    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if(this.projectId && projectmsg){
      projectmsg.map(item=>{
        if(item.type == 4 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`
        }
      })

    }
    //loadconfig
    this.apiService
      .loadConfig("./assets/config/practiceList.json")
      .subscribe((result) => {
        this.practiceList.forEach(function (item, index) {
          if (result[item.title] != null) {
            item["extends"] = result[item.title];
          }
        });
      });

    this.apiService
      .ajax({
        type: "get",
        url: "/api/concatenation/" + this.learningPathId,
        data: {
          learningPathId: this.learningPathId,
        },
      })
      .subscribe((comment) => {
        comment.forEach(function (item, index) {
          if (item.title == "情景模拟") {
            that.chuanjie = item.comment;
          }
        });
      });

    this.apiService
      .ajax({
        type: "get",
        url: "/sr/learningtour",
      })
      .subscribe((result) => {
        this.learningPathMetas = result.learning_path_metas;
        this.learningTour =
          result.pre_survey_meta_ids.length > 0;
        this.abilityConfig
          .getOnceinoByPracticeMetaId(this.practiceMetaId)
          .subscribe((result) => {
            this.finishStatus = result == 1;
            for (var i = 0; i <= this.practiceList.length - 1; i++) {
              if (this.practiceList[i].status != 2) {
                temp = false;
              }
            }
            this.finished = temp;

            this.getLearningPathMetaId();
            // this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
            //   this.questionnaireInfo = result;
            //   this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.isShow !== 1)) && this.learningPathSubItems.filter(d=>d.type === 3)[0].progress ===100 && this.learningPathSubItems.filter(d=>d.type === 4)[0].progress!==100 ? true : false;
            // });

            setTimeout(() => {
              if (this.finished) {
                //新能力考核 version == 1 时,有能力考核,出现考核按钮,完成按钮不出现
                if (this.version == 1) {
                  $("#surveyBtn").fadeIn(200);
                } else {
                  $("#nextWrap").show().animate({ bottom: 0 });
                }
              }
            }, 1000);
          });
      });
  }

  //获取进度
  getProgress(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds='+String(learningPathMetaId),
    }).toPromise();
  }

  //获取用户学习 metaid and version
  getLearningPathMetaId() {
    var that = this;
    this.learningPathMetas.forEach(function (item, i) {
      if (item.learningPathId == that.learningPathId) {
        if(that.type){
          $('#learningPathMetaIdContainer').val(item.id)
        }
        that.learningPathMetaId = item.id;
        that.getOrCreateLearningPath(String(that.learningPathMetaId)).then(result=>{
          that.learningPath = result;
          that.commonService.setCustomLockDate(that.learningPath,Date());
          that.learningPathSubItems = that.learningPath.subItems;
        }).then(()=>{
          return that.getUserQuestionnaireInfo(that.learningPathMetaId).then(result=>{
            return that.questionnaireInfo = result;
          });
        }).then(()=>{
          return that.getProgress(that.learningPathMetaId).then(result=>{
            //向LMS传递进度
            if(localStorage.getItem("source_env") === "LMS_SCORM"){
              that.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',result[0].progressList[0].progress,"data");
            }
            return that.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'] ;
          })
        }).then(()=>{
          that.approachTheme.colorSystem = 'dark';
          that.approachTheme.label = ['能力诊断','课程学习','情景模拟','能力考核'];
          that.approachTheme.currentIndex = that.currentIndex -2;
          that.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
          that.approachTheme.btnTxt = '开启能力考核';
          that.isShowQuestionnaire = that.questionnaireInfo && that.questionnaireInfo.length === 0 && that.learningPath.subItems.filter(d => d.type === 3)[0].progress === 100 && that.learningPath.subItems.filter(d => d.type === 4)[0].progress !== 100;
        }).then(()=>{
          //增加学习断点
          that.commonService.addUserBreakPoint({'learningPathMetasId':Number(that.learningPathMetaId),'moduleId':3,'breakpointUrl':that.platformLocation['location']['href'],'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
          that.isCustomLock = that.learningPathSubItems[3].isLock;
          that.isShowApproach = true;
        });

        if (item.version) {
          that.version = item.version;
        }
      }
    });
  }

  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      backgroundColor: "white",
    });
  }  //展示难忘瞬间gallary
  momentView(mlist,$event) {
    this.showMoment = true;
    this.momentList = mlist;
    $event.stopPropagation();
  }
  //关闭难忘瞬间gallary
  momentExit(){
    this.showMoment = false;
  }
  goToNextStep(i) {
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
    this.onSetPracticeIndex.emit(i);
    // 如果是访客点击永远从头开始情景模拟
    if (this.userType) {
      this.onGoToNextStep.emit(1);
    } else {
      //正式用户流程

      //区分专业版
      var isProfessional = this.learningPathMetaId == 607;
      if(!isProfessional){
        if (this.practiceList[i].status == 2) {
          let link = [
            "case-practice-report-new",
            this.practiceId,
            this.practiceList[i].id,
            this.learningPathId,
          ];
          if (this.practiceMetaId == 10) {
            link = [
              "case-practice-report-new-2",
              this.practiceId,
              this.practiceList[i].id,
              this.learningPathId,
            ];
          }
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        } else if (this.practiceMetaId == 10) {
          let link = [
            "case-practice-hotel",
            this.practiceId,
            this.practiceList[i].id,
            this.learningPathId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }

        } else if (
          this.practiceMetaId == 9 &&
          this.practiceList[i].title == "供应商，真让人头大"
        ) {
          let link = [
            "case-practice-influence-supplier",
            this.learningPathId,
            this.practiceId,
            this.practiceList[i].id,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        } else {
          this.apiService
            .ajax({
              type: "get",
              url: "/api/pnoStorePoint/" + this.practiceList[i].id,
            })
            .subscribe((result) => {
              if (result.status == 0 || result.status == 5) {
                this.onGoToNextStep.emit(1);
              } else if (result.status == 10) {
                let link = [
                  "case-practice-influence-main",
                  this.learningPathId,
                  this.practiceId,
                  this.practiceList[i].id,
                ];
                if(this.type){
                  this.router.navigate(link,{queryParams:{type:'huatek'}});
                }else{
                  this.router.navigate(link);
                }
                if(this.practiceList[0].status!==2){
                  const exerciseMetaId=$('#exerciseMetaId').val()
                  this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
                    console.log(result)
                  })
                  console.log(exerciseMetaId)
                  this.commonService.sendPostMessage(0,'isPractice' +'Complete')
                }
              }
            });
        }
      }else{
        //专业版

        //第一个情景模拟
        if(this.practiceList[i].exerciseMetaId === 60701){
          let link = [
            "case-practice-influence-pro-main",
            this.learningPathId,
            this.practiceId,
            this.practiceList[i].id
          ];
          if (this.practiceList[i].status == 2) {
            link = [
              "case-practice-report-new",
              this.practiceId,
              this.practiceList[i].id,
              this.learningPathId,
            ];
          }
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }

        //第二个情景模拟
        if(this.practiceList[i].exerciseMetaId === 60702){
          let link = [
            "case-practice-influence-supplier",
            this.learningPathId,
            this.practiceId,
            this.practiceList[i].id,
            "607"
          ];
          if (this.practiceList[i].status == 2) {
            link = [
              "case-practice-report-new",
              this.practiceId,
              this.practiceList[i].id,
              this.learningPathId,
            ];
          }
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }

        //第三个情景模拟
        if(this.practiceList[i].exerciseMetaId === 60703){
          let link = [
            "case-practice-influence-supplier",
            this.learningPathId,
            this.practiceId,
            this.practiceList[i].id,
            "607"
          ];
          if (this.practiceList[i].status == 2) {
            link = [
              "case-practice-report-new",
              this.practiceId,
              this.practiceList[i].id,
              this.learningPathId,
            ];
          }
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }
      }
    }
  }

  goToPostSurvey() {
    if( this.type === 'huatek'){
      this.commonService.sendPostMessage(1,'goPostSurvey')
      return
    }else{
      if(this.lock){
        this.showToast();
        return
      }

      this.apiService
      .ajax({
        type: "GET",
        url:
          "/sr/exposeoutapi/setAbilitySession/" +
          this.learningPathMetaId +
          "/4",
      })
      .subscribe((result) => {});
      let link;
      link = ["ability-survey", this.learningPathMetaId, 2];
      // if (this.practiceMetaId == 10) {
      //   link = ["survey", this.learningPathId, 13, 1];
      // } else {
      //   link = ["survey", this.learningPathId, 15, 1];
      // }
      // //新能力考核
      // if (this.version == 1) {
      //   link = ["ability-survey", this.learningPathMetaId, 2];
      // }
      this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'情景模拟','btnName':this.approachTheme.btnTxt,'userId':localStorage.getItem("userId")}).then();
      this.router.navigate(link);
    }

  }

  showToast(){
    this.isShowToast = true;
    setTimeout(()=>{
      this.isShowToast = false;
    },2000);
  }

  finish() {
    if (this.finishStatus) {
      return;
    } else {
      this.abilityConfig
        .setOnceinoByPracticeMetaId(this.practiceMetaId)
        .subscribe();

      let link = ["learning-map"];
      this.router.navigate(link);
    }
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        // 只在learningTour里出现，当完成能力是退出进入map
        if ((this.finishStatus || !this.finished) && this.learningTour) {
          let link = ["learning-map", 3];
          this.router.navigate(link);
        } else if (!this.finishStatus && this.finished && this.learningTour) {
          this.abilityConfig
            .setOnceinoByPracticeMetaId(this.practiceMetaId)
            .subscribe(
              (result) => {
                let link = ["learning-map", 3];
                this.router.navigate(link);
              },
              (error) => {
                let link = ["error"];
                this.router.navigate(link);
              }
            );
        } else {
          let link = ["learning-path", result.data];
          this.router.navigate(link);
        }
      });
  }

  closeQuestionnaire(){
    this.isShowQuestionnaire = false;
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-list/case-practice-influence-list.component.ts